import request from '@/utils/request'

let Job_needApi = {

  /*我要作业列表*/
  list(data) {
    return request._post('/shop/plus.job_need.Index/index', data);
},
/*添加我要作业*/
add(data) {
    return request._post('/shop/plus.job_need.Index/add', data);
},
/*修改我要作业*/
edit(data) {
    return request._post('/shop/plus.job_need.Index/edit', data);
},
/*删除我要作业*/
del(data) {
    return request._post('/shop/plus.job_need.Index/del', data);
},
/*我要作业详情*/
detail(data) {
  return request._post('/shop/plus.job_need.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.job_need.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.job_need.Setting/getSetting', data, errorback);
    },
}
export default Job_needApi;



// WEBPACK FOOTER //
// ./src/api/job_need.js